<template>
  <div class="invoices-history">
    <div class="is-flex space-between">
      <h1 class="title is-4 has-text-primary title-history">
        Historial de Documentos
      </h1>

      <div>
        <p>
          <a
            class="button is-primary btn-download-csv"
            :class="{ 'is-loading': isLoading }"
            :disabled="isLoading"
            @click="downloadCfdis"
          >
            <BIcon icon="cloud-download" />
            <span> Descarga CSV</span>
          </a>
        </p>
      </div>
    </div>

    <AppPagination
      class="is-centered"
      :current-page="currentPage"
      :buttons-max="buttonsMax"
      :pages-total="totalPages"
      @change="goToPage"
    />

    <div class="history-container">
      <b-table
        :data="invoices"
        :loading="isLoading"
        detailed
        :has-detailed-visible="(row)=>row.operation.payments.length > 0"
        :row-class="(row) => [201, 202].includes(row.operation.status) && 'is-danger'"
        mobile-cards
      >
        <template slot-scope="props">
          <b-table-column
            field="voucherSeries"
            label="Folio - Serie"
            centered
          >
            <template
              slot="header"
              slot-scope="{ column }"
            >
              <div class="is-flex voucher-type-selector">
                <span>
                  {{ column.label }}
                </span>
                <b-dropdown
                  v-model="type"
                  hoverable
                  aria-role="list"
                  @change="onChangeType"
                >
                  <span
                    slot="trigger"
                    class="filter"
                  >
                    <b-icon
                      icon="filter"
                      type="is-info"
                    />
                  </span>

                  <b-dropdown-item
                    :focusable="false"
                    aria-role="menu-item"
                    custom
                    paddingless
                  >
                    <form
                      action=""
                      @submit.prevent
                    >
                      <div
                        class="modal-card"
                        style="width:250px;"
                      >
                        <div class="modal-card-body">
                          <b-field label="Buscar por Serie">
                            <b-input
                              name="voucherSeries"
                              :value="$route.query.voucherSeries"
                              placeholder="A"
                              @input.native="onInputSearcherRouter"
                            />
                          </b-field>
                          <b-field label="Buscar por Folio">
                            <b-input
                              name="voucherConsecutive"
                              :value="$route.query.voucherConsecutive"
                              placeholder="123"
                              @input.native="onInputSearcherRouter"
                            />
                          </b-field>
                        </div>
                      </div>
                    </form>
                  </b-dropdown-item>
                </b-dropdown>

                <router-link
                  v-if="$route.query.voucherSeries || $route.query.voucherConsecutive"
                  style="cursor: pointer;"
                  :to="{
                    query: {
                      ...$route.query,
                      voucherSeries: undefined,
                      voucherConsecutive: undefined,
                    }
                  }"
                >
                  <b-icon
                    icon="close"
                    type="is-danger"
                  />
                </router-link>
              </div>
            </template>

            <span>{{ props.row.voucherSeries }}</span>
            <span style="padding: 0 .5rem;">-</span>
            <span>{{ props.row.voucherConsecutive }}</span>
          </b-table-column>

          <b-table-column
            field="voucherDate"
            label="Fecha y Hora"
            centered
          >
            {{ props.row.voucherDate | toHumanDateTime }}
          </b-table-column>

          <b-table-column
            field="receiverRfc"
            label="RFC Receptor"
            centered
          >
            <template
              slot="header"
              slot-scope="{ column }"
            >
              <div class="is-flex voucher-type-selector">
                <span>
                  {{ column.label }}
                </span>
                <b-dropdown
                  v-model="type"
                  hoverable
                  aria-role="list"
                  @change="onChangeType"
                >
                  <span
                    slot="trigger"
                    class="filter"
                  >
                    <b-icon
                      icon="filter"
                      type="is-info"
                    />
                  </span>

                  <b-dropdown-item
                    :focusable="false"
                    aria-role="menu-item"
                    custom
                    paddingless
                  >
                    <form
                      action=""
                      @submit.prevent
                    >
                      <div
                        class="modal-card"
                        style="width:250px;"
                      >
                        <div class="modal-card-body">
                          <b-field label="Buscar por RFC cliente">
                            <b-input
                              name="receiverRfc"
                              :value="$route.query.receiverRfc"
                              placeholder="XAXX010101000"
                              @input.native="onInputSearcherRouter"
                            />
                          </b-field>
                        </div>
                      </div>
                    </form>
                  </b-dropdown-item>
                </b-dropdown>
                <router-link
                  v-if="$route.query.receiverRfc"
                  style="cursor: pointer;"
                  :to="{ query: { ...$route.query, receiverRfc: undefined } }"
                >
                  <b-icon
                    icon="close"
                    type="is-danger"
                  />
                </router-link>
              </div>
            </template>

            <template v-if="props.row.voucherType === 'N'">
              {{ props.row.receiverRfc }}
            </template>
            <template v-else>
              <RouterLink
                :to="{ name: 'CustomerEdit', params: { customer: props.row.operation.customer } }"
              >
                {{ props.row.receiverRfc }}
              </RouterLink>
            </template>
          </b-table-column>

          <b-table-column
            field="operation.name"
            label="Nombre del Cliente"
            centered
          >
            <template
              slot="header"
              slot-scope="{ column }"
            >
              <div class="is-flex voucher-type-selector">
                <span>
                  {{ column.label }}
                </span>
                <b-dropdown
                  v-model="type"
                  hoverable
                  aria-role="list"
                  @change="onChangeType"
                >
                  <span
                    slot="trigger"
                    class="filter"
                  >
                    <b-icon
                      icon="filter"
                      type="is-info"
                    />
                  </span>

                  <b-dropdown-item
                    :focusable="false"
                    aria-role="menu-item"
                    custom
                    paddingless
                  >
                    <form
                      action=""
                      @submit.prevent
                    >
                      <div
                        class="modal-card"
                        style="width:250px;"
                      >
                        <div class="modal-card-body">
                          <b-field label="Buscar por nombre del Cliente">
                            <b-input
                              name="operation.name"
                              :value="$route.query['operation.name']"
                              placeholder="Nombre cliente"
                              @input.native="onInputSearcherRouter"
                            />
                          </b-field>
                        </div>
                      </div>
                    </form>
                  </b-dropdown-item>
                </b-dropdown>
                <router-link
                  v-if="$route.query['operation.name']"
                  style="cursor: pointer;"
                  :to="{ query: { ...$route.query, 'operation.name': undefined } }"
                >
                  <b-icon
                    icon="close"
                    type="is-danger"
                  />
                </router-link>
              </div>
            </template>

            <template v-if="props.row.voucherType === 'N'">
              {{ props.row.operation.name }}
            </template>
            <template v-else>
              <RouterLink
                :to="{ name: 'CustomerEdit', params: { customer: props.row.operation.customer } }"
              >
                {{ props.row.operation.name }}
              </RouterLink>
            </template>
          </b-table-column>

          <b-table-column
            field="receiverName"
            label="Razón social Cliente"
            centered
          >
            <template
              slot="header"
              slot-scope="{ column }"
            >
              <div class="is-flex voucher-type-selector">
                <span>
                  {{ column.label }}
                </span>
                <b-dropdown
                  v-model="type"
                  hoverable
                  aria-role="list"
                  @change="onChangeType"
                >
                  <span
                    slot="trigger"
                    class="filter"
                  >
                    <b-icon
                      icon="filter"
                      type="is-info"
                    />
                  </span>

                  <b-dropdown-item
                    :focusable="false"
                    aria-role="menu-item"
                    custom
                    paddingless
                  >
                    <form
                      action=""
                      @submit.prevent
                    >
                      <div
                        class="modal-card"
                        style="width:250px;"
                      >
                        <div class="modal-card-body">
                          <b-field label="Buscar por Razón social del cliente">
                            <b-input
                              name="receiverName"
                              :value="$route.query.receiverName"
                              placeholder="Empresa SA de CV"
                              @input.native="onInputSearcherRouter"
                            />
                          </b-field>
                        </div>
                      </div>
                    </form>
                  </b-dropdown-item>
                </b-dropdown>
                <router-link
                  v-if="$route.query.receiverName"
                  style="cursor: pointer;"
                  :to="{ query: { ...$route.query, receiverName: undefined } }"
                >
                  <b-icon
                    icon="close"
                    type="is-danger"
                  />
                </router-link>
              </div>
            </template>

            <template v-if="props.row.voucherType === 'N'">
              {{ props.row.receiverName }}
            </template>
            <template v-else>
              <RouterLink
                :to="{ name: 'CustomerEdit', params: { customer: props.row.operation.customer } }"
              >
                {{ props.row.receiverName }}
              </RouterLink>
            </template>
          </b-table-column>

          <b-table-column
            field="voucherCurrency"
            label="Moneda"
            centered
          >
            <template
              slot="header"
              slot-scope="{ column }"
            >
              <div class="is-flex voucher-type-selector">
                <span>
                  {{ column.label }}
                </span>
                <b-dropdown
                  v-model="type"
                  hoverable
                  aria-role="list"
                  @change="onChangeType"
                >
                  <span
                    slot="trigger"
                    class="filter"
                  >
                    <b-icon
                      icon="filter"
                      type="is-info"
                    />
                  </span>

                  <b-dropdown-item
                    :focusable="false"
                    aria-role="menu-item"
                    custom
                    paddingless
                  >
                    <form
                      action=""
                      @submit.prevent
                    >
                      <div class="filter-currency">
                        <b-field label="Buscar por moneda">
                          <AppSelectSearch
                            id="filterCurrency"
                            name="voucherCurrency"
                            placeholder="Selecciona una moneda"
                            :options="currencies()"
                            :value="$route.query.voucherCurrency"
                            @input="onInputSearcherRouter"
                            @change="onInputSearcherRouter"
                          />
                        </b-field>
                      </div>
                    </form>
                  </b-dropdown-item>
                </b-dropdown>
                <router-link
                  v-if="$route.query.voucherCurrency"
                  style="cursor: pointer;"
                  :to="{ query: { ...$route.query, voucherCurrency: undefined } }"
                >
                  <b-icon
                    icon="close"
                    type="is-danger"
                  />
                </router-link>
              </div>
            </template>
            <span
              v-if="props.row.voucherType !== 'P'"
            >
              {{ props.row.voucherCurrency }}
            </span>
            <span
              v-else
            >
              {{ props.row.complement.payments[0].currency }}
            </span>
          </b-table-column>

          <b-table-column
            v-if="props.row.voucherType !== 'P'"
            field="voucherTotal"
            label="Total"
            centered
          >
            {{ props.row.voucherTotal | toCurrency(props.row.voucherCurrency) }}
          </b-table-column>
          <b-table-column
            v-else
            field="voucherTotal"
            label="Total"
            centered
          >
            {{ props.row.complement.payments[0].amount
              | toCurrency(props.row.complement.payments[0].currency) }}
          </b-table-column>

          <b-table-column
            field="voucherType"
            label="Tipo"
            centered
          >
            <template
              slot="header"
              slot-scope="{ column }"
            >
              <div class="is-flex voucher-type-selector">
                <span>
                  {{ column.label }}
                </span>
                <b-dropdown
                  v-model="type"
                  hoverable
                  aria-role="list"
                  @change="onChangeType"
                >
                  <span
                    slot="trigger"
                    class="filter"
                  >
                    <b-icon
                      icon="filter"
                      type="is-info"
                    />
                  </span>

                  <b-dropdown-item
                    v-for="t in types"
                    :key="t.value"
                    :value="t.value"
                    aria-role="listitem"
                  >
                    {{ t.label }}
                  </b-dropdown-item>
                </b-dropdown>
                <div
                  v-if="type"
                  style="cursor: pointer;"
                  @click.prevent="cleanTypeSelected"
                >
                  <b-icon
                    icon="close"
                    type="is-danger"
                  />
                </div>
              </div>
            </template>
            {{ voucherTypeLabel(voucherType(props.row)) }}
          </b-table-column>

          <b-table-column
            field="voucherPaymentMethod"
            label="Método de pago"
            centered
          >
            <template
              slot="header"
              slot-scope="{ column }"
            >
              <div class="is-flex voucher-type-selector">
                <span>
                  {{ column.label }}
                </span>
                <b-dropdown
                  v-model="type"
                  hoverable
                  aria-role="list"
                  position="is-bottom-left"
                  @change="onChangeType"
                >
                  <span
                    slot="trigger"
                    class="filter"
                  >
                    <b-icon
                      icon="filter"
                      type="is-info"
                    />
                  </span>

                  <b-dropdown-item
                    :focusable="false"
                    aria-role="menu-item"
                    custom
                    paddingless
                  >
                    <form
                      action=""
                      @submit.prevent
                    >
                      <div
                        class="modal-card"
                        style="width:200px;"
                      >
                        <div class="modal-card-body">
                          <b-field label="Tipo de documento">
                            <div class="is-flex">
                              <b-radio-button
                                v-model="voucherPaymentMethodRadioButton"
                                native-value="PUE"
                                expanded
                                type="is-primary"
                              >
                                <span>PUE</span>
                              </b-radio-button>

                              <b-radio-button
                                v-model="voucherPaymentMethodRadioButton"
                                native-value="PPD"
                                expanded
                                type="is-primary"
                              >
                                <span>PPD</span>
                              </b-radio-button>
                            </div>
                          </b-field>
                        </div>
                      </div>
                    </form>
                  </b-dropdown-item>
                </b-dropdown>
                <a
                  v-if="$route.query.voucherPaymentMethod"
                  style="cursor: pointer;"
                  @click="voucherPaymentMethodRadioButton = ''"
                >
                  <b-icon
                    icon="close"
                    type="is-danger"
                  />
                </a>
              </div>
            </template>

            <BTooltip
              v-if="isExpired(props.row)"
              type="is-danger"
              label="El tiempo de pago expiró"
            >
              <span class="tag is-danger">
                {{ props.row.voucherPaymentMethod }}
              </span>
            </BTooltip>
            <span v-else>
              {{ props.row.voucherPaymentMethod }}
            </span>
          </b-table-column>

          <b-table-column
            field="operation.cfdiStatus"
            label="Estado CFDI"
          >
            {{ getCfdiStatus(props.row) }}
          </b-table-column>

          <b-table-column
            field="id"
            label="Acciones"
            centered
          >
            <invoice-actions
              v-if="voucherType(props.row) === 'invoice'"
              :id="props.row.id"
              :invoice="props.row"
            />

            <pre-invoice-actions
              v-if="voucherType(props.row) === 'pre'"
              :id="props.row.id"
              :voucher-type="props.row.voucherType"
            />

            <auto-invoice-actions
              v-if="voucherType(props.row) === 'autoInvoice'"
              :id="props.row.id"
              :invoice="props.row"
            />

            <credit-note-actions
              v-if="voucherType(props.row) === 'creditNote'"
              :id="props.row.id"
              :invoice="props.row"
            />

            <payroll-actions
              v-if="voucherType(props.row) === 'payroll'"
              :id="props.row.id"
              :invoice="props.row"
            />

            <rep-actions
              v-if="voucherType(props.row) === 'rep'"
              :id="props.row.id"
              :invoice="props.row"
            />

            <salary-receipt-actions
              v-if="voucherType(props.row) === 'salaryReceipt'"
              :id="props.row.id"
              :invoice="props.row"
            />

            <sale-note-actions
              v-if="voucherType(props.row) === 'saleNote'"
              :id="props.row.id"
              :invoice="props.row"
            />

            <trade-transfer-actions
              v-if="voucherType(props.row) === 'tradeTransfer'"
              :id="props.row.id"
              :invoice="props.row"
            />
          </b-table-column>
        </template>

        <template
          slot="detail"
          slot-scope="props"
        >
          <div class="history-container-detail">
            <b-table
              :data="getPayments(props.row.operation.payments)"
              :loading="isLoading"
            >
              <template slot-scope="props1">
                <b-table-column
                  field="voucherSeries"
                  label="Folio - Serie"
                  centered
                >
                  <span>{{ props1.row.cfdi.voucherSeries }}</span>
                  <span style="padding: 0 .5rem;">-</span>
                  <span>{{ props1.row.cfdi.voucherConsecutive }}</span>
                </b-table-column>

                <b-table-column
                  field="voucherDate"
                  label="Fecha y Hora"
                  centered
                >
                  {{ props1.row.cfdi.voucherDate | toHumanDateTime }}
                </b-table-column>

                <b-table-column
                  field="voucherCurrency"
                  label="Moneda"
                  centered
                >
                  {{ props1.row.cfdi.complement.payments[0].currency }}
                </b-table-column>

                <b-table-column
                  field="voucherTotal"
                  label="Total"
                  centered
                >
                  {{ paymentAmount(props1.row.cfdi, props.row.operation.payments) }}
                </b-table-column>

                <b-table-column
                  field="id"
                  label="Acciones"
                  centered
                >
                  <rep-actions
                    v-if="voucherType(props1.row.cfdi) === 'rep'"
                    :id="props1.row.id"
                    :invoice="props.row"
                  />
                </b-table-column>
              </template>

              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <p>
                      <b-icon
                        icon="emoticon-sad"
                        size="is-large"
                      />
                    </p>
                    <p>No has generado ningún documento</p>
                  </div>
                </section>
              </template>
            </b-table>
          </div>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon
                  icon="emoticon-sad"
                  size="is-large"
                />
              </p>
              <p>No has generado ningún documento</p>
            </div>
          </section>
        </template>
      </b-table>
    </div>

    <AppPagination
      class="is-centered"
      :current-page="currentPage"
      :buttons-max="buttonsMax"
      :pages-total="totalPages"
      @change="goToPage"
    />
  </div>
</template>

<script>
import moment from 'moment';
import { mapState, mapGetters, mapActions } from 'vuex';
import { currency } from '@machete/common-catalogs';
import utils from '../../../lib/utils';

export default {
  name: 'History',
  components: {
    AppPagination: () => import(/* webpackChunkName: "app-pagination" */ '../../../components/AppPagination.vue'),
    AutoInvoiceActions: () => import(/* webpackChunkName: "history-auto-invoice-actions" */ '../../../components/Invoices/History/AutoInvoiceActions.vue'),
    CreditNoteActions: () => import(/* webpackChunkName: "history-credit-note-actions" */ '../../../components/Invoices/History/CreditNoteActions.vue'),
    InvoiceActions: () => import(/* webpackChunkName: "history-invoice-actions" */ '../../../components/Invoices/History/InvoiceActions.vue'),
    PayrollActions: () => import(/* webpackChunkName: "history-payroll-actions" */ '../../../components/Invoices/History/PayrollActions.vue'),
    PreInvoiceActions: () => import(/* webpackChunkName: "history-preinvoice-actions" */ '../../../components/Invoices/History/PreInvoiceActions.vue'),
    RepActions: () => import(/* webpackChunkName: "history-rep-actions" */ '../../../components/Invoices/History/RepActions.vue'),
    SalaryReceiptActions: () => import(/* webpackChunkName: "history-salary-receipt-actions" */ '../../../components/Invoices/History/SalaryReceiptActions.vue'),
    SaleNoteActions: () => import(/* webpackChunkName: "history-sale-note-actions" */ '../../../components/Invoices/History/SaleNoteActions.vue'),
    TradeTransferActions: () => import(/* webpackChunkName: "history-trade-transfer-actions" */ '../../../components/Invoices/History/TradeTransferActions.vue'),
    AppSelectSearch: () => import(/* webpackChunkName: "app-select-search" */ '@/components/AppSelectSearch.vue'),
  },
  data() {
    return {
      voucherPaymentMethodRadioButton: '',
      isLoading: false,
      buttonsMax: 5,
      modal: false,
      invoiceToCanel: '',
      listRep: [],
      type: '',
      types: [
        {
          value: 'pre',
          label: 'Pre Factura',
        },
        {
          value: 'invoice',
          label: 'Factura',
        },
        {
          value: 'creditNote',
          label: 'Nota de Crédito',
        },
        {
          value: 'payroll',
          label: 'Nómina',
        },
        {
          value: 'tradeTransfer',
          label: 'Traslado',
        },
        {
          value: 'rep',
          label: 'REP',
        },
        {
          value: 'saleNote',
          label: 'Nota de Remisión',
        },
        {
          value: 'auto',
          label: 'Auto Factura',
        },
        {
          value: 'salaryReceipt',
          label: 'Recibo de Salario',
        },
      ],
      currencies: () => currency.map(
        ({ key, value }) => ({
          value: key,
          label: `${key} - ${value}`,
        }),
      ),
    };
  },
  computed: {
    ...mapState({
      total: state => state.invoices.total,
      totalPages: state => state.invoices.totalPages,
      company: state => state.company.id,
    }),
    ...mapGetters({
      invoices: 'invoices/cleanInvoices',
    }),
    isExpired() {
      return (row) => {
        if (row.voucherPaymentMethod !== 'PPD') return null;
        return moment(row.operation.expirationDate) < moment();
      };
    },
    voucherType() {
      return invoice => utils.getDocumentType(invoice);
    },
    voucherTypeLabel() {
      return (type) => {
        let label = 'Pre Factura';

        switch (type) {
          case 'invoice':
            label = 'Factura';
            break;
          case 'creditNote':
            label = 'Nota de Crédito';
            break;
          case 'payroll':
            label = 'Nómina';
            break;
          case 'tradeTransfer':
            label = 'Traslado';
            break;
          case 'rep':
            label = 'REP';
            break;
          case 'saleNote':
            label = 'Nota de Remisión';
            break;
          case 'autoInvoice':
            label = 'Auto Factura';
            break;
          case 'salaryReceipt':
            label = 'Recibo de Salario';
            break;
          default:
            break;
        }

        return label;
      };
    },
    lastPage() {
      return Math.ceil(this.invoices.length / this.itemsPerPage);
    },
    currentPage() {
      return parseInt(this.$route.query.page, 10);
    },
    size() {
      return this.$route.query.size;
    },
  },
  watch: {
    voucherPaymentMethodRadioButton(value) {
      if (!value) {
        this.$router.push({ query: { ...this.$route.query, voucherPaymentMethod: undefined } });
      } else {
        this.$router.push({ query: { ...this.$route.query, voucherPaymentMethod: value } });
      }
    },
    buttonsMax(newValue, oldValue) {
      if (newValue % 2) {
        return;
      }
      if (newValue < oldValue) {
        this.buttonsMax = newValue - 1;
      }
      if (newValue > oldValue) {
        this.buttonsMax = newValue + 1;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.page) next();
    else {
      next({ name: to.name, query: { page: 1, size: 20 } });
    }
  },

  async beforeRouteUpdate(to, from, next) {
    await this.getAll(to.query);

    next();
  },

  async mounted() {
    this.isLoading = true;

    await this.getAll(this.$route.query);

    this.listRep = await this.searchInvoices({
      filter: 'rep',
    });

    this.isLoading = false;
  },
  methods: {
    ...mapActions({
      getAll: 'invoices/getAll',
      cancelByUuid: 'invoice/cancelByUuid',
      searchInvoices: 'invoices/searchInvoices',
    }),
    onChangeType(type) {
      this.$router.push({ query: { page: 1, size: 20, filter: type } });
    },
    getPayments(payments) {
      const relation = [];

      payments.forEach((payment) => {
        relation.push(
          this.listRep.find(
            invoice => invoice.cfdi.complement.digitalTaxStamp.uuid === payment.uuid,
          ),
        );
      });

      return relation;
    },
    paymentAmount(payment, invoicePayments) {
      const paymentFound = invoicePayments.find(
        invoicePayment => payment.complement.digitalTaxStamp.uuid === invoicePayment.uuid,
      );
      return (utils.toCurrency(paymentFound.amount, paymentFound.currency, 2));
    },
    cleanTypeSelected() {
      this.type = '';
      this.$router.push({ query: { ...this.$route.query, filter: '' } });
    },
    async downloadCfdis() {
      const now = new Date();

      this.$store.commit('ui/addNotification', {
        type: 'info',
        content: 'Descargando...',
        dateTime: now,
      });

      await this.$store.dispatch('invoices/downloadAll');

      this.$store.commit('ui/deleteNotification', now);
    },
    goToPage(page) {
      const { size = 20 } = this.$route.query;
      const filterParms = this.$route.query;

      delete filterParms.page;
      delete filterParms.size;

      const query = {
        page,
        size,
        ...filterParms,
      };

      this.$router.push({ query });
    },
    checkLastPage() {
      if (this.currentPage < this.lastPage) {
        this.$router.push({ query: { page: this.lastPage } });
      }
    },
    onInputSearcherRouter(event) {
      this.$router.push({
        query: { ...this.$route.query, [event.target.name]: event.target.value, page: 1 },
      });
    },
    async regeneratePdf(type, invoice) {
      const companyId = this.company;
      try {
        const now = new Date();
        this.$store.commit('ui/addNotification', {
          type: 'info',
          content: 'Generando...',
          datetime: now,
        });
        await this.$store.dispatch('invoice/regeneratePdf', { invoice, companyId });
        this.$store.commit('ui/deleteNotification', now);
        this.$store.dispatch('addTemporalNotification', {
          type: 'success',
          content: 'Pdf generado correctamente',
        });
      } catch (error) {
        this.$store.dispatch('addTemporalNotification', {
          type: 'danger',
          content: `
            Ocurrió un error al tratar de generar el pdf. <br>
            ${error.message}
          `,
        });
      }
    },
    getCfdiStatus(row) {
      const documents = [
        'invoice',
        'creditNote',
        'tradeTransfer',
        'payroll',
        'rep',
      ];

      const documentType = this.voucherType(row);

      if (([201, 202].includes(row.operation.status) && !row.operation.cfdiStatus)
        || !documents.includes(documentType)) {
        return '';
      }

      return row.operation.cfdiStatus || 'Vigente';
    },
  },
};
</script>

<style lang="sass">
tr.is-danger
  background: $danger
  color: $white

  a:not(.action-option)
    color: $white
    text-decoration: underline

  a.action-option
    border-radius: 50%
    padding: .25rem
</style>

<style scoped>
.history-container-detail{
  margin-top: 0;
}

.history-container {
  padding: 1rem 0;
}

.router-link-active span.icon.is-small {
  color: white !important;
}

.invoices-history {
  padding: 1rem;
}

.menu-docs {
  display: flex;
  flex-direction: row;
  padding-bottom: 1.5rem;
}

.field.has-addons {
  margin-bottom: 1.5rem;
}

.is-flex.space-between {
  justify-content: space-between;
}
</style>

<style>
.invoices-history .field.has-addons a.router-link-active.button .icon {
  color: white!important;
}

.invoices-history .action-option {
  display: flex;
  flex-direction: column;
}

.invoices-history .b-table .table th .th-wrap .dropdown-trigger .icon {
  margin-left: 0;
}

.invoices-history .b-table .table th {
  vertical-align: middle;
}

.invoices-history .is-flex.voucher-type-selector {
  justify-content: space-between;
  align-items: center;
}

.invoices-history .voucher-type-selector .filter {
  cursor: pointer;
}

.filter-currency {
  display: block;
  width: 250px;
  padding: 20px 5px;
}

#filterCurrency .dropdown-menu {
  display: block;
  max-height: 300px !important;
}
</style>
